/** SmartCafe UI — az, tr, ru, en */
const az = {
  common: {
    loading: "Yüklənir…",
    save: "Saxla",
    delete: "Sil",
    back: "Geri",
    all: "Hamısı",
    detail: "Detay",
    update: "Yenilə",
    add: "Əlavə et",
    filter: "Filtr",
    clear: "Təmizlə",
    print: "Yazdır",
    empty: "Boş",
    occupied: "Dolu",
    yes: "Bəli",
    no: "Xeyr",
    close: "Bağla",
    continue: "Davam et",
    user: "İstifadəçi",
    logout: "Çıxış",
    darkMode: "Gecə rejimi",
    lightMode: "Gündüz rejimi",
    menu: "Menyu",
    order: "Sifariş",
    posSystem: "POS System",
    definitions: "Tənimlər",
    unknownError: "Naməlum xəta baş verdi",
    listCount: "Siyahıda cəmi {count} qeyd var.",
  },
  lang: {
    settingsTitle: "Dil ayarları",
    settingsDesc:
      "Proqramın interfeys dili. Seçim restoran üçün saxlanılır və bütün cihazlarda tətbiq olunur.",
    current: "Cari dil",
    save: "Dili saxla",
    saved: "Dil yeniləndi",
    saveError: "Dil saxlanmadı",
    loadError: "Dil məlumatı yüklənmədi",
  },
  nav: {
    dashboard: "Ana Panel",
    tables: "Masalar",
    orders: "Sifarişlər",
    customers: "Müştərilər",
    cash: "Kassa",
    warehouseProducts: "Anbara Məhsul",
    rawMaterials: "Xammal",
    sets: "Setlər",
    staffRegistration: "İşçi Qeydiyyatı",
    courierRegistration: "Kuryer Qeydiyyatı",
    tableSettings: "Masa Nizamlamaları",
    generalSettings: "Ümumi Nizamlamalar",
    telegramBot: "Telegram Bot",
    expenses: "Xərclər",
    groupWarehouse: "Anbar və Məhsul",
    groupStaff: "Heyət və Kuryer",
    groupSettings: "Nizamlamalar",
    groupFinance: "Maliyyə",
    backupReady: "Backup hazırdır! {count} qeyd endirildi. {errors} endpoint əlçatmaz idi.",
    webOrders: "Web sifarişlər",
    webOrdersHint: "Onlayn menyu sifarişləri",
    webOrdersEmpty: "Web sifarişi yoxdur",
    webOrdersAll: "Bütün web sifarişlər →",
    newWebOrder: "Yeni web sifarişiniz var!",
    webOrderDetail: "Sifariş detalları",
    webOrdersPending: "gözləyən sifariş",
    webOrderAccept: "Qəbul et",
    webOrderAcceptOpen: "Qəbul et və aç",
    webOrderReject: "Ləğv et",
    webOrderRejectConfirm: "Bu web sifarişi ləğv etmək istəyirsiniz?",
    webOrderRejected: "Sifariş ləğv edildi",
    webOrderAccepted: "Sifariş qəbul edildi",
    webOrderActionError: "Əməliyyat uğursuz oldu",
    webOrderDetailError: "Detallar yüklənmədi",
    webOrderCustomer: "Müştəri məlumatı",
    webOrderFullPage: "Tam səhifədə aç",
  },
  login: {
    emailPasswordRequired: "Email və şifrə tələb olunur",
    invalidCredentials: "Email və ya şifrə yanlışdır",
    dbConnection:
      "API verilənlər bazasına qoşula bilmir. Canlı MySQL üçün START_FULL_DEV.bat, lokal test üçün scripts\\use-local-sqlite.ps1.",
    apiUnavailable: "Giriş baş tutmadı. API işləyirmi? (http://127.0.0.1:8000)",
    retry: "Giriş baş tutmadı. Yenidən cəhd edin.",
    tagline: "Restoran idarəetmə sistemi",
    headline: "Restoranınızı ağıllı idarə edin",
    heroDesc: "Masalar, sifarişlər, stok və hesabatlar — hamısı bir yerdə.",
    welcome: "Xoş gəlmisiniz",
    subtitle: "Davam etmək üçün hesabınıza daxil olun",
    email: "Email",
    password: "Şifrə",
    remember: "Məni xatırla",
    forgotPassword: "Şifrəni unutdum?",
    submit: "Daxil ol",
    submitting: "Giriş edilir…",
    showPassword: "Göstər",
    hidePassword: "Gizlət",
    headlineLine1: "Restoranınızı",
    headlineHighlight: "ağıllı",
    headlineLine2: "idarə edin",
    featureMobileTitle: "Mobil uyğun",
    featureMobileText: "Telefon, tablet və masaüstündə eyni rahatlıqla",
    featureReportsTitle: "Canlı hesabatlar",
    featureReportsText: "Gündəlik kassa və satış analizləri anında",
    featureSecureTitle: "Təhlükəsiz",
    featureSecureText: "Məlumatlarınız şifrələnmiş bağlantı ilə qorunur",
    copyright: "Bütün hüquqlar qorunur",
    noAccount: "Hesabınız yoxdur? İş birliyi və demo üçün",
  },
  settings: {
    title: "Ümumi Nizamlamalar",
    selectCategory: "Kateqoriya seçin",
    tabGeneral: "Ayarlar",
    tabGeneralDesc: "Restoran, loqo, printer, rənglər",
    tabPassword: "Şifrə Nizamlaması",
    tabPasswordDesc: "Bölmə-əsaslı şifrələr",
    tabLanguage: "Dil Ayarları",
    tabLanguageDesc: "Türk, Rus, Azərbaycan",
    tabWeb: "Web Ayarları",
    tabWebDesc: "Onlayn menyu, link, domain",
    tabAppearance: "Görünüş",
    tabAppearanceDesc: "Menyu səhifələri və funksiyaları gizlət / göstər",
    tabTelegram: "Telegram Bot",
    tabTelegramDesc: "Sifariş və kassa bildirişləri",
    mainMenuSection: "Əsas menyu",
    tanimMenuSection: "Tanımlar menyu",
    featuresSection: "Funksiyalar",
    featuresSectionDesc: "Səhifə daxilindəki düymələr və əlavə funksiyalar",
    featureQuickSale: "Hızlı satış",
    featureQuickSaleDesc: "Sifarişlər səhifəsindəki sürətli satış düyməsi",
    optionsSection: "Davranış ayarları",
    optionsSectionDesc: "Səhifəyə girəndə avtomatik açılma və s. funksiyalar",
    optionQuickSaleAuto: "Hızlı satış avtomatik",
    optionQuickSaleAutoDesc: "Sifarişlər açılanda birbaşa hızlı satış; satışdan sonra yenidən açılır",
    pagesVisible: "səhifə görünür",
    appearanceSaved: "Görünüş ayarları saxlanıldı",
    appearanceSaveError: "Görünüş ayarları saxlanılmadı",
    generalIntro:
      "Restoran profili, printerlər, masa rəngləri və iş saatları.",
    saved: "Parametrlər uğurla yeniləndi",
    profileSection: "Profil və loqo",
    profileLogo: "Logo (.jpg, .png) — istəyə bağlı",
    restaurantName: "Kafe / restoran adı",
    receiptFooter: "Fiş altı mesajı",
    qrEnable: "QR menyunu aktiv et",
    qrOrders: "QR menyudan sifariş qəbul et",
    printers: "Printerlər",
    mainPrinter: "Ana / hesab yazıcı",
    kitchenPrinter: "Mətbəx yazıcı",
    barPrinter: "Bar yazıcı",
    tableColors: "Masa rəngləri və PS Club",
    emptyTable: "Boş masa",
    bookedTable: "Dolu masa",
    psClub: "PS Club",
    psActive: "Aktiv",
    psOff: "Söndürülüb",
    saveChanges: "Dəyişiklikləri saxla",
  },
  webSettings: {
    title: "Web Ayarları",
    intro: "Masa QR-dan ayrı — bir link ilə çatdırılma sifarişi. Öz domaininizi yönləndirə bilərsiniz.",
    loading: "Yüklənir...",
    loadError: "Web ayarları yüklənmədi",
    saved: "Web ayarları saxlanıldı",
    saveError: "Saxlama uğursuz oldu",
    save: "Saxla",
    publicLink: "İctimai menyu linki",
    publicLinkHint: "Bu linki Instagram bio, WhatsApp status və s. üçün paylaşın. Masa QR kodları ayrıca qalır.",
    slug: "Link adı (slug)",
    slugHint: "Yalnız kiçik hərf, rəqəm və tire. Məs: my-cafe",
    copy: "Kopyala",
    linkCopied: "Link kopyalandı",
    copyFailed: "Kopyalama alınmadı",
    preview: "Menyuya bax",
    menuActive: "Web menyu aktiv",
    acceptOrders: "Onlayn sifariş qəbul et (Sifarişlər bölməsinə düşür)",
    customDomain: "Öz domain",
    customDomainIntro: "Öz domaininizi daxil edin, DNS qeydlərini edin — SmartCafe super-admin panelindən aktiv ediləndən sonra menyu açılacaq.",
    domainField: "Domain (məs: menu.restoran.az)",
    domainNone: "Domain yoxdur",
    domainPending: "Gözləyir — paneldən aktivləşdirilməlidir",
    domainActive: "Aktiv — domain işləyir",
    domainRejected: "Rədd edilib",
    domainActiveLocked: "Aktiv domaini dəyişmək üçün super-admin ilə əlaqə saxlayın.",
    dnsTitle: "DNS quraşdırması",
    dnsStep1: "Subdomain üçün CNAME: menu (və ya istədiyiniz ad) → {cname}",
    dnsStep2: "Və ya A qeydi ilə birbaşa IP: {ip}",
    dnsStep3: "Domaini saxladıqdan sonra super-admin panelində Web domain bölməsindən aktiv edin",
    dnsPendingHint: "DNS yayıldıqdan sonra super-admin domaini aktiv edəcək. login.smartcafe.az/menu/slug linki həmişə işləyir.",
    dnsActiveHint: "{domain} aktivdir — müştərilər bu ünvanda menyunu görəcək.",
    dnsRejectedHint: "Domain rədd edilib. DNS-i düzəldib yenidən saxlayın.",
    domainNote: "Domain haqqında qeyd (dəstək üçün)",
    domainNotePlaceholder: "Məs: menu.bistro.az — aktivləşdirmə istəyirəm",
    design: "Dizayn",
    templatePick: "Web dizayn şablonu",
    templatePickHint: "Müştəri linkində görünəcək dizaynı seçin. Flame Sushi tərzi qaranlıq restoran menyusuna uyğundur.",
    template_classic: "Klassik — açıq, sadə",
    template_flame: "Flame — qaranlıq, qırmızı vurğu",
    template_modern: "Modern — gradient, şüşə effekt",
    webTitle: "Başlıq",
    webSubtitle: "Alt başlıq",
    themeColor: "Əsas rəng",
    bgColor: "Fon rəngi",
    logoFromProfile: "Loqo ümumi ayarlardan götürülür",
    bannerImage: "Banner şəkli (loqo arxa planı)",
    bannerHint: "Geniş banner yükləyin — loqo onun üstündə görünəcək. Tövsiyə: 1200×400 px",
    bannerUpload: "Banner seç",
    bannerRemove: "Banneri sil",
    bannerRemoved: "Banner silindi",
    bioLinks: "Sosial linklər",
    bioLinksHint: "Restoran konumu (Google Maps), TikTok və WhatsApp — veb sayt əvəzinə bu linklər menyuda görünür.",
    locationUrl: "Restoran konumu (Google Maps linki)",
    website: "Veb sayt",
    promoCode: "Promo Kod",
    comingSoon: "Bu bölmə tezliklə aktiv olacaq.",
    layoutHint: "Sol menyudan bölmə seçin",
    promoSettings: "Promo ayarları",
    promoSettingsHint: "Minimum sifariş məbləği və endirim kodlarını idarə edin.",
    minOrderAmount: "Minimum sifariş məbləği (₼)",
    minOrderHint: "Boş buraxsanız minimum limit tətbiq olunmur.",
    promoLoadError: "Promo kodlar yüklənmədi",
    promoSaved: "Promo kod saxlanıldı",
    promoSaveError: "Promo kod saxlanmadı",
    promoCodeRequired: "Promo kod daxil edin",
    promoDeleteConfirm: "Promo kod silinsin?",
    promoDeleted: "Promo kod silindi",
    promoEdit: "Promo redaktə",
    promoNew: "Yeni promo kod",
    promoCodeField: "Kod",
    promoTitle: "Başlıq",
    promoDescription: "Açıqlama",
    promoDiscountType: "Endirim növü",
    promoPercent: "Faiz (%)",
    promoFixed: "Sabit məbləğ",
    promoValue: "Dəyər",
    promoMaxUses: "Maks. istifadə (boş = limitsiz)",
    promoValidFrom: "Başlanğıc",
    promoValidUntil: "Bitmə",
    promoActive: "Aktiv",
    promoInactive: "Deaktiv",
    promoAdd: "Əlavə et",
    promoUpdate: "Yenilə",
    promoCancel: "Ləğv et",
    promoList: "Promo kodlar",
    promoEmpty: "Hələ promo kod yoxdur.",
    promoUses: "İstifadə: {count} / {max}",
    promoWaiting: "Tarix gözləyir",
    promoExpired: "Müddəti bitib",
    promoMaxUses: "Limit dolub",
    promoDateHint: "Boş buraxsanız promo daim aktiv olur. Tarixlər Bakı vaxtı ilə saxlanılır.",
    promoClearDates: "Tarixləri sil",
  },
  pwd: {
    title: "Şifrə Nizamlaması",
    subtitle:
      "Pin kodları restoranınız üçün MySQL-də bcrypt hash kimi saxlanır.",
    custom: "Özəl",
    default: "Default",
    disabled: "Söndürülüb",
    setPassword: "Şifrəni təyin et",
    newPassword: "Yeni şifrə",
    hintEnter: "4-6 rəqəm",
    hintConfirm: "Təsdiq üçün təkrar daxil edin",
    keypadClear: "Təmizlə",
    keypadBack: "Geri",
    keypadSave: "Yadda saxla",
    keypadSaving: "Saxlanır…",
    minDigits: "Şifrə ən az 4 rəqəm olmalıdır",
    mismatch: "Şifrələr uyğun gəlmir",
    azaltmaLabel: "Məhsul azaltma",
    azaltmaDesc: "Masadakı məhsul sayını azaltmaq üçün şifrə",
    silmeLabel: "Silmə",
    silmeDesc: "Masadan məhsul silmək üçün şifrə",
    legvLabel: "Masa ləğvi",
    legvDesc: "Masanı bağlamaq / ləğv etmək üçün şifrə",
    anbarLabel: "Anbar",
    anbarDesc: "Anbar, stok və məhsul tənzimləmələri üçün şifrə",
    kassaLabel: "Kassa",
    kassaDesc: "Gündəlik kassa və maliyyə hesabatları üçün şifrə",
    ekranLabel: "Ekran kilidi",
    ekranDesc: "POS boş qaldıqda ekranı kilidləmək üçün pin",
    screenLockTitle: "Ekran kilidi vaxtı",
    screenLockDesc: "POS müəyyən müddət işləməsə ekran kilidi pin tələb olunur.",
    screenLockIdle: "Boş qalma müddəti",
    screenLockHint: "Ekran kilidi aktiv olmalı və müddət 0-dan böyük olmalıdır.",
    screenLockSaved: "Ekran kilidi vaxtı saxlanıldı",
    screenLockOff: "Söndürülüb",
    screenLock30: "30 saniyə",
    screenLock60: "1 dəqiqə",
    screenLock120: "2 dəqiqə",
    screenLock180: "3 dəqiqə",
    screenLock300: "5 dəqiqə",
    screenLock600: "10 dəqiqə",
    loadError: "Tənzimləmələri yükləmək alınmadı",
    updatedOnServer: "— serverdə yeniləndi",
  },
  masalar: {
    totalTables: "Ümumi masa",
    empty: "Boş",
    occupied: "Dolu",
    activeTurnover: "Aktiv dövriyyə",
    search: "Masa axtar…",
    refresh: "Yenilə",
    tableSettings: "Masa ayarları",
    noTables: "Masa tapılmadı",
    tableOptions: "Masa seçimləri",
  },
  masaSiparis: {
    productAdded: "Məhsul əlavə olundu",
    orderName: "Sifarişin adı",
    tables: "Masalar",
    menu: "Menyu",
    order: "Sifariş",
    psTime: "PS vaxtı",
  },
  siparisler: {
    title: "Sifarişlər",
    subtitle: "Çatdırılma və web sifarişlərini idarə edin",
    addNew: "Yeni sifariş əlavə edin",
    fullName: "Ad Soyad",
    time: "Saat",
    total: "Toplam",
    phone: "Telefon",
    address: "Ünvan",
    courier: "Kuryer",
    closeBill: "Hesab kəs",
    saleComplete: "Satış tamamlandı",
    tabWeb: "Web sifarişlər",
    tabManual: "Telefon / manual",
    searchPlaceholder: "Ad, telefon və ya ünvan axtar…",
    statAll: "Ümumi sifariş",
    statWeb: "Web sifariş",
    statWebPending: "Gözləyən web",
    statTotal: "Cəmi məbləğ",
    empty: "Sifariş tapılmadı",
    openMap: "Xəritədə aç",
    assignCourier: "Kuryer təyin et",
    actions: "Əməliyyat",
    loadError: "Sifarişlər yüklənmədi",
    deleteConfirm: "Bu sifarişi silmək istəyirsiniz?",
    deleted: "Sifariş silindi",
    courierAssigned: "Kuryer təyin edildi",
    addModalSubtitle: "Müştəri məlumatlarını daxil edin, sonra məhsul seçin",
    namePlaceholder: "Məs: Əli Məmmədov",
    phonePlaceholder: "+994 XX XXX XX XX",
    addressPlaceholder: "Küçə, bina, mənzil…",
    useLocation: "GPS konum göndər",
    locationAdded: "Konum əlavə edildi",
    locationError: "Konum alına bilmədi",
    locationUnsupported: "Brauzer konum dəstəkləmir",
    fieldRequired: "Ad, telefon və ünvan mütləqdir",
    continueToMenu: "Məhsul seçin →",
    quickSale: "Hızlı satış",
    quickSaleHint: "Məhsula klikləyin — sifariş hazırdır (müştəri məlumatı istəyə bağlıdır)",
    customerOptionalHint: "Müştəri məlumatı istəyə bağlıdır — boş buraxsanız da satış edə bilərsiniz",
    anonymousCustomer: "Qonaq",
    fillCustomerFirst: "Əvvəl ad və ünvan daxil edin",
    searchProduct: "Məhsul axtar…",
  },
  musteriSiparis: {
    title: "Sifariş yarat",
    subtitle: "Məhsul əlavə edin, hesab kəsin və çatdırın",
    customerInfo: "Müştəri məlumatları",
    updateCustomer: "Məlumatları saxla",
    customerUpdated: "Müştəri məlumatları yeniləndi",
    currentCart: "Cari sifariş",
    menuProducts: "Məhsul menyusu",
    noItems: "Hələ məhsul əlavə edilməyib",
    prepayment: "Ön ödəniş",
    paid: "Artıq ödənilib",
    remaining: "Qalıq",
    sendKitchen: "Mətbəxə yazdır",
    sendToKitchen: "Mətbəxə göndər",
    colName: "Ad",
    colQty: "Say",
    colKitchen: "Mətbəx",
    selectVariant: "Variant seçin",
    addToOrder: "Sifarişə əlavə et",
    specialOrders: "Xüsusi sifarişlər",
    specialIngredient: "Xüsusi tərkib",
    ingredientPlaceholder: "Xüsusi tərkib daxil edin",
  },
  musteriler: {
    title: "Müştərilər",
    addNew: "Yeni müştəri əlavə edin",
    filterName: "Ad filtr",
    filterPhone: "Telefon filtr",
    selectCustomer: "Zəhmət olmasa müştəri seçin",
  },
  gunlukKasa: {
    title: "Gündəlik kassa",
    subtitle: "Ödənişlər, nağd və bank hesabatı",
    start: "Başlanğıc",
    end: "Bitmə tarixi",
    paymentType: "Ödəniş növü",
    cash: "Nağd pul",
    card: "Bank / kart",
    tableOrName: "Masa / Ad soyad",
    opened: "Açılış",
    closed: "Bağlanma",
    duration: "Müddət",
    amount: "Cəmi",
    statTotal: "Ümumi kassa",
    statCash: "Nağd",
    statBank: "Bank",
    statCount: "Əməliyyat",
    searchPlaceholder: "Masa və ya ad axtar…",
    employee: "İşçi",
    detail: "Ətraflı",
    orders: "Sifarişlər",
    itemName: "Məhsul",
    qty: "Miqdar",
    price: "Qiymət",
    printReceipt: "Qəbz çap",
    deleteConfirm: "Bu ödənişi silmək istəyirsiniz?",
    deleted: "Ödəniş silindi",
    empty: "Ödəniş tapılmadı",
    loadError: "Kassa məlumatları yüklənmədi",
    paymentSplit: "Hissə-hissə",
    customerBalance: "Müştəri hesabı",
    exportExcel: "Excel",
    exportPdf: "PDF",
    reportPrint: "Hesabat çap",
    registerOpen: "Kassa Aç",
    registerClose: "Kassa Bağla",
    registerIsOpen: "Kassa açıqdır",
    registerIsClosed: "Kassa bağlıdır",
    registerOpened: "Kassa açıldı",
    registerClosed: "Kassa bağlandı",
    registerOpenedAt: "Açılış",
    registerSessionTotal: "Sessiya cəmi",
    registerCloseConfirm: "Kassanı bağlamaq istəyirsiniz?",
    registerToggleError: "Kassa əməliyyatı alınmadı",
  },
  stok: {
    title: "Anbar məhsul əlavə edilməsi",
    addNew: "Yeni stok əlavə edin",
    addGroup: "Qrup / kateqoriya əlavə edin",
    resetInventory: "Anbarı sıfırla",
    resetConfirm: "Anbarı sıfırlamağa əminsiniz?",
    resetSuccess: "Anbar uğurla sıfırlandı",
    name: "Adı",
    stock: "Stok",
    salePrice: "Satış qiyməti",
    qrMenu: "QR menyu",
    group: "Qrup",
    woltImportTitle: "Wolt-dan menyu import",
    woltImportHint: "Wolt restoran linkini yapışdırın — kateqoriya və məhsullar avtomatik çəkilir",
    woltUrlPlaceholder: "https://wolt.com/az/aze/baku/restaurant/...",
    woltUrlRequired: "Wolt linki daxil edin",
    woltFetch: "Menyunu çək",
    woltPreviewError: "Wolt menyusu yüklənmədi",
    woltCategories: "kateqoriya",
    woltProducts: "məhsul",
    woltShowOnQr: "QR menyuda göstər",
    woltSkipExisting: "Eyni adlı məhsulları atla",
    woltDownloadImages: "Şəkilləri yüklə",
    woltDefaultStock: "Default stok sayı",
    woltSearchItems: "Məhsul axtar…",
    woltSelectAll: "Hamısını seç",
    woltClearAll: "Seçimi sil",
    woltSelectItems: "Ən azı bir məhsul seçin",
    woltImportConfirm: "{count} məhsul anbara əlavə olunsun?",
    woltImportBtn: "Anbara import et",
    woltImportDone: "Import tamamlandı",
    woltAdded: "əlavə",
    woltSkipped: "atlandı",
    woltImportError: "Import alınmadı",
    woltImportWait: "Import bir neçə dəqiqə çəkə bilər — gözləyin…",
  },
  couriers: {
    title: "Kuryer tərifləri",
    addNew: "+ Yeni kuryer əlavə edin",
    fullName: "Ad soyad",
    phone: "Telefon",
    address: "Ünvan",
  },
  masaTanimlari: {
    groupsTitle: "Masa qrupları",
    newGroup: "Yeni masa qrupu",
    tablesTitle: "Masa tərifləri",
    newTable: "+ Yeni masa",
    tableName: "Masa adı",
    group: "Qrup",
    unspecified: "Göstərilməyib",
  },
  personel: {
    title: "Kadr tərifləri",
    subtitle: "İşçi qeydiyyatı, rol və icazələr",
    addNew: "Yeni işçi",
    addTitle: "Yeni işçi əlavə et",
    editTitle: "İşçini yenilə",
    fullName: "Ad soyad",
    email: "E-mail",
    type: "Rol",
    password: "Şifrə",
    passwordHint: "Ən az 6 rəqəm (PIN)",
    passwordConfirm: "Şifrə təsdiqi",
    newPassword: "Yeni şifrə",
    passwordOptional: "Boş buraxsanız dəyişməz",
    selectRole: "Rol seçin",
    roleGeneral: "Menecer (Genel)",
    roleWaiter: "Ofisiant",
    permissionsTitle: "İcazələr",
    perm_manage_tables: "Masa əməliyyatları (hesab aç/bağla)",
    perm_manage_quick_orders: "Sifariş əməliyyatları",
    perm_manage_customers: "Müştərilərə giriş",
    perm_access_payments: "Kassaya giriş",
    perm_manage_payments: "Kassadan silmə",
    perm_manage_tanimlar: "Təriflər (anbar, masa və s.)",
    perm_manage_restaurants: "Ümumi ayarlar",
    searchPlaceholder: "Ad, e-mail və ya rol axtar…",
    statTotal: "Cəmi işçi",
    permCount: "icazə",
    empty: "Hələ işçi yoxdur",
    deleteConfirm: "{name} silinsin?",
    added: "İşçi əlavə edildi",
    updated: "İşçi yeniləndi",
    deleted: "İşçi silindi",
    loadError: "İşçilər yüklənmədi",
    saveError: "Əməliyyat alınmadı",
    errName: "Ad mütləqdir",
    errNameLong: "Ad çox uzundur",
    errEmail: "E-mail mütləqdir",
    errEmailInvalid: "E-mail düzgün deyil",
    errType: "Rol seçin",
    errPermissions: "Ən azı bir icazə seçin",
    errPassword: "Şifrə mütləqdir",
    errPasswordShort: "Şifrə ən az 6 rəqəmdən ibarət olmalıdır",
    errPasswordMatch: "Şifrələr uyğun gəlmir",
  },
  expenses: {
    title: "Kateqoriyalar",
    newCategory: "Yeni kateqoriya adı",
    total: "Toplam",
    amount: "Məbləğ",
    reason: "Səbəb",
    addExpense: "Xərc əlavə et",
    noCategory: "Kateqoriya seçilməyib",
  },
  material: {
    addTitle: "Xammal əlavə et",
    name: "Adı",
    namePlaceholder: "Xammal adı…",
    unit: "Vahid",
    selectUnit: "Vahid seçin",
    unitPiece: "Ədəd",
    listTitle: "Mövcud xammallar",
    quantity: "Miqdar",
    actions: "Əməliyyatlar",
    deleted: "Xammal silindi",
    updated: "Xammal yeniləndi",
    noLogs: "Heç bir log tapılmadı",
  },
  account: {
    inactive:
      "Hesabınız aktiv deyil. Aktivləşdirmək üçün {phone} ilə əlaqə saxlayın.",
  },
  accessDenied: "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur",
  notFound: {
    title: "Vay! Səhifə tapılmadı.",
    desc: "Axtardığınız səhifə mövcud deyil.",
    home: "Əsas səhifəyə qayıt",
  },
};

const tr = {
  common: {
    loading: "Yükleniyor…",
    save: "Kaydet",
    delete: "Sil",
    back: "Geri",
    all: "Tümü",
    detail: "Detay",
    update: "Güncelle",
    add: "Ekle",
    filter: "Filtre",
    clear: "Temizle",
    print: "Yazdır",
    empty: "Boş",
    occupied: "Dolu",
    yes: "Evet",
    no: "Hayır",
    close: "Kapat",
    continue: "Devam",
    user: "Kullanıcı",
    logout: "Çıkış",
    menu: "Menü",
    order: "Sipariş",
    posSystem: "POS Sistemi",
    definitions: "Tanımlar",
    unknownError: "Bilinmeyen hata oluştu",
    listCount: "Listede toplam {count} kayıt var.",
  },
  lang: {
    settingsTitle: "Dil ayarları",
    settingsDesc:
      "Program arayüz dili. Seçim restoran için kaydedilir ve tüm cihazlarda geçerlidir.",
    current: "Geçerli dil",
    save: "Dili kaydet",
    saved: "Dil güncellendi",
    saveError: "Dil kaydedilemedi",
    loadError: "Dil bilgisi yüklenemedi",
  },
  nav: {
    dashboard: "Ana Panel",
    tables: "Masalar",
    orders: "Siparişler",
    customers: "Müşteriler",
    cash: "Kasa",
    warehouseProducts: "Depo Ürünleri",
    rawMaterials: "Hammadde",
    sets: "Setler",
    staffRegistration: "Personel Kaydı",
    courierRegistration: "Kurye Kaydı",
    tableSettings: "Masa Ayarları",
    generalSettings: "Genel Ayarlar",
    telegramBot: "Telegram Bot",
    expenses: "Giderler",
    groupWarehouse: "Depo ve Ürün",
    groupStaff: "Personel ve Kurye",
    groupSettings: "Ayarlar",
    groupFinance: "Finans",
    backupReady: "Yedek hazır! {count} kayıt indirildi. {errors} uç nokta erişilemedi.",
    webOrders: "Web siparişler",
    webOrdersHint: "Online menü siparişleri",
    webOrdersEmpty: "Web siparişi yok",
    webOrdersAll: "Tüm web siparişler →",
    newWebOrder: "Yeni web siparişiniz var!",
    webOrderDetail: "Sipariş detayları",
    webOrdersPending: "bekleyen sipariş",
    webOrderAccept: "Kabul et",
    webOrderAcceptOpen: "Kabul et ve aç",
    webOrderReject: "İptal et",
    webOrderRejectConfirm: "Bu web siparişi iptal etmek istiyor musunuz?",
    webOrderRejected: "Sipariş iptal edildi",
    webOrderAccepted: "Sipariş kabul edildi",
    webOrderActionError: "İşlem başarısız",
    webOrderDetailError: "Detaylar yüklenemedi",
    webOrderCustomer: "Müşteri bilgisi",
    webOrderFullPage: "Tam sayfada aç",
  },
  login: {
    emailPasswordRequired: "E-posta ve şifre gerekli",
    invalidCredentials: "E-posta veya şifre hatalı",
    dbConnection: "API veritabanına bağlanılamıyor. START_FULL_DEV.bat veya use-local-sqlite.ps1.",
    apiUnavailable: "Giriş başarısız. API çalışıyor mu?",
    retry: "Giriş başarısız. Tekrar deneyin.",
    tagline: "Restoran yönetim sistemi",
    headline: "Restoranınızı akıllıca yönetin",
    heroDesc: "Masalar, siparişler, stok ve raporlar — hepsi bir arada.",
    welcome: "Hoş geldiniz",
    subtitle: "Devam etmek için hesabınıza giriş yapın",
    email: "E-posta",
    password: "Şifre",
    remember: "Beni hatırla",
    forgotPassword: "Şifremi unuttum?",
    submit: "Giriş yap",
    submitting: "Giriş yapılıyor…",
    showPassword: "Göster",
    hidePassword: "Gizle",
    headlineLine1: "Restoranınızı",
    headlineHighlight: "akıllıca",
    headlineLine2: "yönetin",
    featureMobileTitle: "Mobil uyumlu",
    featureMobileText: "Telefon, tablet ve masaüstünde",
    featureReportsTitle: "Canlı raporlar",
    featureReportsText: "Günlük kasa ve satış analizleri",
    featureSecureTitle: "Güvenli",
    featureSecureText: "Verileriniz şifreli bağlantı ile korunur",
    copyright: "Tüm hakları saklıdır",
    noAccount: "Hesabınız yok mu? İş birliği ve demo için",
  },
  settings: {
    title: "Genel Ayarlar",
    selectCategory: "Kategori seçin",
    tabGeneral: "Ayarlar",
    tabGeneralDesc: "Restoran, logo, yazıcı, renkler",
    tabPassword: "Şifre Ayarları",
    tabPasswordDesc: "Bölüm bazlı şifreler",
    tabLanguage: "Dil Ayarları",
    tabLanguageDesc: "Türkçe, Rusça, Azerbaycanca",
    tabWeb: "Web Ayarları",
    tabWebDesc: "Online menü, link, domain",
    tabAppearance: "Görünüm",
    tabAppearanceDesc: "Menü sayfalarını ve özellikleri gizle / göster",
    tabTelegram: "Telegram Bot",
    tabTelegramDesc: "Sipariş ve kasa bildirimleri",
    mainMenuSection: "Ana menü",
    tanimMenuSection: "Tanımlar menüsü",
    featuresSection: "Özellikler",
    featuresSectionDesc: "Sayfa içi butonlar ve ek özellikler",
    featureQuickSale: "Hızlı satış",
    featureQuickSaleDesc: "Siparişler sayfasındaki hızlı satış butonu",
    optionsSection: "Davranış ayarları",
    optionsSectionDesc: "Sayfaya girince otomatik açılma vb. özellikler",
    optionQuickSaleAuto: "Hızlı satış otomatik",
    optionQuickSaleAutoDesc: "Siparişler açılınca doğrudan hızlı satış; satıştan sonra tekrar açılır",
    pagesVisible: "sayfa görünür",
    appearanceSaved: "Görünüm ayarları kaydedildi",
    appearanceSaveError: "Görünüm ayarları kaydedilemedi",
    generalIntro: "Restoran profili, yazıcılar, masa renkleri ve çalışma saatleri.",
    saved: "Ayarlar başarıyla güncellendi",
    profileSection: "Profil ve logo",
    profileLogo: "Logo (.jpg, .png) — isteğe bağlı",
    restaurantName: "Kafe / restoran adı",
    receiptFooter: "Fiş altı mesajı",
    qrEnable: "QR menüyü etkinleştir",
    qrOrders: "QR menüden sipariş al",
    printers: "Yazıcılar",
    mainPrinter: "Ana yazıcı",
    kitchenPrinter: "Mutfak yazıcısı",
    barPrinter: "Bar yazıcısı",
    tableColors: "Masa renkleri ve PS Club",
    emptyTable: "Boş masa",
    bookedTable: "Dolu masa",
    psClub: "PS Club",
    psActive: "Aktif",
    psOff: "Kapalı",
    saveChanges: "Değişiklikleri kaydet",
  },
  webSettings: {
    title: "Web Ayarları",
    intro: "Masa QR'dan ayrı — tek link ile teslimat siparişi. Kendi domaininizi yönlendirebilirsiniz.",
    loading: "Yükleniyor...",
    loadError: "Web ayarları yüklenemedi",
    saved: "Web ayarları kaydedildi",
    saveError: "Kaydetme başarısız",
    save: "Kaydet",
    publicLink: "Halka açık menü linki",
    publicLinkHint: "Bu linki Instagram bio vb. için paylaşın. Masa QR kodları ayrı kalır.",
    slug: "Link adı (slug)",
    slugHint: "Sadece küçük harf, rakam ve tire",
    copy: "Kopyala",
    linkCopied: "Link kopyalandı",
    copyFailed: "Kopyalama başarısız",
    preview: "Menüyü gör",
    menuActive: "Web menü aktif",
    acceptOrders: "Online sipariş al (Siparişler bölümüne düşer)",
    customDomain: "Özel domain",
    customDomainIntro: "Domaininizi bu menüye yönlendirmek için adımları izleyin veya bize ulaşın.",
    domainField: "Domain (ör: menu.restoran.com)",
    domainNone: "Domain yok",
    domainPending: "Bekliyor — destek aktifleştirecek",
    domainActive: "Aktif",
    dnsTitle: "DNS kurulumu",
    dnsStep1: "CNAME kaydı: menu → login.smartcafe.az",
    dnsStep2: "Veya A kaydı ile sunucu IP (destek verecek)",
    dnsStep3: "Domain girdikten sonra bize yazın — sunucuda aktifleştirilecek",
    dnsSupport: "Yardım için SmartCafe desteğine ulaşın.",
    domainNote: "Domain notu (destek için)",
    domainNotePlaceholder: "ör: menu.bistro.com — aktifleştirme istiyorum",
    design: "Tasarım",
    templatePick: "Web tasarım şablonu",
    templatePickHint: "Müşteri linkinde görünecek tasarımı seçin.",
    template_classic: "Klasik — açık, sade",
    template_flame: "Flame — koyu, kırmızı vurgu",
    template_modern: "Modern — gradient, cam efekt",
    webTitle: "Başlık",
    webSubtitle: "Alt başlık",
    themeColor: "Ana renk",
    bgColor: "Arka plan",
    logoFromProfile: "Logo genel ayarlardan alınır",
    bannerImage: "Banner görseli (logo arka planı)",
    bannerHint: "Geniş banner yükleyin — logo üstünde görünür. Öneri: 1200×400 px",
    bannerUpload: "Banner seç",
    bannerRemove: "Banneri kaldır",
    bannerRemoved: "Banner kaldırıldı",
    bioLinks: "Sosyal linkler",
    bioLinksHint: "Restoran konumu, TikTok ve WhatsApp — web sitesi yerine menüde görünür.",
    locationUrl: "Restoran konumu (Google Maps)",
    website: "Web sitesi",
    promoCode: "Promo Kod",
    comingSoon: "Bu bölüm yakında aktif olacak.",
    layoutHint: "Sol menüden bölüm seçin",
    promoSettings: "Promo ayarları",
    promoSettingsHint: "Minimum sipariş tutarı ve indirim kodlarını yönetin.",
    minOrderAmount: "Minimum sipariş tutarı (₼)",
    minOrderHint: "Boş bırakırsanız minimum limit uygulanmaz.",
    promoLoadError: "Promo kodlar yüklenemedi",
    promoSaved: "Promo kod kaydedildi",
    promoSaveError: "Promo kod kaydedilemedi",
    promoCodeRequired: "Promo kod girin",
    promoDeleteConfirm: "Promo kod silinsin mi?",
    promoDeleted: "Promo kod silindi",
    promoEdit: "Promo düzenle",
    promoNew: "Yeni promo kod",
    promoCodeField: "Kod",
    promoTitle: "Başlık",
    promoDescription: "Açıklama",
    promoDiscountType: "İndirim türü",
    promoPercent: "Yüzde (%)",
    promoFixed: "Sabit tutar",
    promoValue: "Değer",
    promoMaxUses: "Maks. kullanım (boş = sınırsız)",
    promoValidFrom: "Başlangıç",
    promoValidUntil: "Bitiş",
    promoActive: "Aktif",
    promoInactive: "Pasif",
    promoAdd: "Ekle",
    promoUpdate: "Güncelle",
    promoCancel: "İptal",
    promoList: "Promo kodlar",
    promoEmpty: "Henüz promo kod yok.",
    promoUses: "Kullanım: {count} / {max}",
  },
  pwd: {
    title: "Şifre Ayarları",
    subtitle: "Pin kodları restoranınız için MySQL'de bcrypt hash olarak saklanır.",
    custom: "Özel",
    default: "Varsayılan",
    disabled: "Kapalı",
    setPassword: "Şifre belirle",
    newPassword: "Yeni şifre",
    hintEnter: "4-6 rakam",
    hintConfirm: "Onay için tekrar girin",
    keypadClear: "Temizle",
    keypadBack: "Geri",
    keypadSave: "Kaydet",
    keypadSaving: "Kaydediliyor…",
    minDigits: "Şifre en az 4 rakam olmalıdır",
    mismatch: "Şifreler uyuşmuyor",
    azaltmaLabel: "Ürün azaltma",
    azaltmaDesc: "Masadaki ürün miktarını azaltmak için şifre",
    silmeLabel: "Silme",
    silmeDesc: "Masadan ürün silmek için şifre",
    legvLabel: "Masa iptali",
    legvDesc: "Masayı kapatmak / iptal için şifre",
    anbarLabel: "Depo",
    anbarDesc: "Depo, stok ve ürün ayarları için şifre",
    kassaLabel: "Kasa",
    kassaDesc: "Günlük kasa ve finans raporları için şifre",
    ekranLabel: "Ekran kilidi",
    ekranDesc: "POS boş kaldığında ekranı kilitlemek için pin",
    screenLockTitle: "Ekran kilidi süresi",
    screenLockDesc: "POS belirli süre kullanılmazsa ekran kilidi pin istenir.",
    screenLockIdle: "Boş kalma süresi",
    screenLockHint: "Ekran kilidi açık olmalı ve süre 0'dan büyük olmalıdır.",
    screenLockSaved: "Ekran kilidi süresi kaydedildi",
    screenLockOff: "Kapalı",
    screenLock30: "30 saniye",
    screenLock60: "1 dakika",
    screenLock120: "2 dakika",
    screenLock180: "3 dakika",
    screenLock300: "5 dakika",
    screenLock600: "10 dakika",
  },
  masalar: {
    totalTables: "Toplam masa",
    empty: "Boş",
    occupied: "Dolu",
    activeTurnover: "Aktif ciro",
    search: "Masa ara…",
    refresh: "Yenile",
    tableSettings: "Masa ayarları",
    noTables: "Masa bulunamadı",
    tableOptions: "Masa seçenekleri",
  },
  masaSiparis: {
    productAdded: "Ürün eklendi",
    orderName: "Sipariş adı",
    tables: "Masalar",
    menu: "Menü",
    order: "Sipariş",
    psTime: "PS süresi",
  },
  siparisler: {
    title: "Siparişler",
    subtitle: "Teslimat ve web siparişlerini yönetin",
    addNew: "Yeni sipariş ekle",
    fullName: "Ad Soyad",
    time: "Saat",
    total: "Toplam",
    phone: "Telefon",
    address: "Adres",
    courier: "Kurye",
    closeBill: "Hesap kes",
    saleComplete: "Satış tamamlandı",
    tabWeb: "Web siparişler",
    tabManual: "Telefon / manuel",
    searchPlaceholder: "Ad, telefon veya adres ara…",
    statAll: "Toplam sipariş",
    statWeb: "Web sipariş",
    statWebPending: "Bekleyen web",
    statTotal: "Toplam tutar",
    empty: "Sipariş bulunamadı",
    openMap: "Haritada aç",
    assignCourier: "Kurye ata",
    actions: "İşlem",
    loadError: "Siparişler yüklenemedi",
    deleteConfirm: "Bu siparişi silmek istiyor musunuz?",
    deleted: "Sipariş silindi",
    courierAssigned: "Kurye atandı",
    addModalSubtitle: "Müşteri bilgilerini girin, ardından ürün seçin",
    namePlaceholder: "Örn: Ali Yılmaz",
    phonePlaceholder: "+90 XXX XXX XX XX",
    addressPlaceholder: "Sokak, bina, daire…",
    useLocation: "GPS konum gönder",
    locationAdded: "Konum eklendi",
    locationError: "Konum alınamadı",
    locationUnsupported: "Tarayıcı konum desteklemiyor",
    fieldRequired: "Ad, telefon ve adres zorunludur",
    continueToMenu: "Ürün seç →",
    quickSale: "Hızlı satış",
    quickSaleHint: "Ürüne tıklayın — sipariş hazır (müşteri bilgisi isteğe bağlı)",
    customerOptionalHint: "Müşteri bilgisi isteğe bağlıdır — boş bırakarak da satış yapabilirsiniz",
    anonymousCustomer: "Misafir",
    fillCustomerFirst: "Önce ad ve adres girin",
    searchProduct: "Ürün ara…",
  },
  musteriSiparis: {
    title: "Sipariş oluştur",
    subtitle: "Ürün ekleyin, hesap kesin ve teslim edin",
    customerInfo: "Müşteri bilgileri",
    updateCustomer: "Bilgileri kaydet",
    customerUpdated: "Müşteri bilgileri güncellendi",
    currentCart: "Mevcut sipariş",
    menuProducts: "Ürün menüsü",
    noItems: "Henüz ürün eklenmedi",
    prepayment: "Ön ödeme",
    paid: "Ödenen",
    remaining: "Kalan",
    sendKitchen: "Mutfağa yazdır",
    sendToKitchen: "Mutfağa gönder",
    colName: "Ad",
    colQty: "Adet",
    colKitchen: "Mutfak",
    selectVariant: "Varyant seçin",
    addToOrder: "Siparişe ekle",
    specialOrders: "Özel siparişler",
    specialIngredient: "Özel malzeme",
    ingredientPlaceholder: "Özel malzeme girin",
  },
  musteriler: {
    title: "Müşteriler",
    addNew: "Yeni müşteri ekle",
    filterName: "Ad filtresi",
    filterPhone: "Telefon filtresi",
    selectCustomer: "Lütfen müşteri seçin",
  },
  gunlukKasa: {
    title: "Günlük kasa",
    subtitle: "Ödemeler, nakit ve bank raporu",
    start: "Başlangıç",
    end: "Bitiş tarihi",
    paymentType: "Ödeme türü",
    cash: "Nakit",
    card: "Banka / kart",
    tableOrName: "Masa / Ad soyad",
    opened: "Açılış",
    closed: "Kapanış",
    duration: "Süre",
    amount: "Toplam",
    statTotal: "Toplam kasa",
    statCash: "Nakit",
    statBank: "Banka",
    statCount: "İşlem",
    searchPlaceholder: "Masa veya ad ara…",
    employee: "Personel",
    detail: "Detay",
    orders: "Siparişler",
    itemName: "Ürün",
    qty: "Adet",
    price: "Fiyat",
    printReceipt: "Fiş yazdır",
    deleteConfirm: "Bu ödemeyi silmek istiyor musunuz?",
    deleted: "Ödeme silindi",
    empty: "Ödeme bulunamadı",
    loadError: "Kasa verileri yüklenemedi",
    paymentSplit: "Parça parça",
    customerBalance: "Müşteri hesabı",
    exportExcel: "Excel",
    exportPdf: "PDF",
    reportPrint: "Rapor yazdır",
    registerOpen: "Kasa Aç",
    registerClose: "Kasa Kapat",
    registerIsOpen: "Kasa açık",
    registerIsClosed: "Kasa kapalı",
    registerOpened: "Kasa açıldı",
    registerClosed: "Kasa kapatıldı",
    registerOpenedAt: "Açılış",
    registerSessionTotal: "Oturum toplamı",
    registerCloseConfirm: "Kasayı kapatmak istiyor musunuz?",
    registerToggleError: "Kasa işlemi başarısız",
  },
  stok: {
    title: "Depo ürün ekleme",
    addNew: "Yeni stok ekle",
    addGroup: "Grup / kategori ekle",
    resetInventory: "Depoyu sıfırla",
    resetConfirm: "Depoyu sıfırlamak istediğinize emin misiniz?",
    resetSuccess: "Depo başarıyla sıfırlandı",
    name: "Adı",
    stock: "Stok",
    salePrice: "Satış fiyatı",
    qrMenu: "QR menü",
    group: "Grup",
    woltImportTitle: "Wolt'tan menü import",
    woltImportHint: "Wolt restoran linkini yapıştırın",
    woltUrlPlaceholder: "https://wolt.com/.../restaurant/...",
    woltUrlRequired: "Wolt linki girin",
    woltFetch: "Menüyü çek",
    woltPreviewError: "Wolt menüsü yüklenemedi",
    woltCategories: "kategori",
    woltProducts: "ürün",
    woltShowOnQr: "QR menüde göster",
    woltSkipExisting: "Aynı isimli ürünleri atla",
    woltDownloadImages: "Görselleri indir",
    woltDefaultStock: "Varsayılan stok",
    woltSearchItems: "Ürün ara…",
    woltSelectAll: "Tümünü seç",
    woltClearAll: "Seçimi temizle",
    woltSelectItems: "En az bir ürün seçin",
    woltImportConfirm: "{count} ürün depoya eklensin mi?",
    woltImportBtn: "Depoya import et",
    woltImportDone: "Import tamamlandı",
    woltAdded: "eklendi",
    woltSkipped: "atlandı",
    woltImportError: "Import başarısız",
    woltImportWait: "Import birkaç dakika sürebilir — bekleyin…",
  },
  couriers: {
    title: "Kurye tanımları",
    addNew: "+ Yeni kurye ekle",
    fullName: "Ad soyad",
    phone: "Telefon",
    address: "Adres",
  },
  masaTanimlari: {
    groupsTitle: "Masa grupları",
    newGroup: "Yeni masa grubu",
    tablesTitle: "Masa tanımları",
    newTable: "+ Yeni masa",
    tableName: "Masa adı",
    group: "Grup",
    unspecified: "Belirtilmemiş",
  },
  personel: {
    title: "Personel tanımları",
    subtitle: "Personel kaydı, rol ve yetkiler",
    addNew: "Yeni personel",
    addTitle: "Yeni personel ekle",
    editTitle: "Personeli güncelle",
    fullName: "Ad soyad",
    email: "E-posta",
    type: "Rol",
    password: "Şifre",
    passwordHint: "En az 6 rakam (PIN)",
    passwordConfirm: "Şifre onayı",
    newPassword: "Yeni şifre",
    passwordOptional: "Boş bırakırsanız değişmez",
    selectRole: "Rol seçin",
    roleGeneral: "Yönetici (Genel)",
    roleWaiter: "Garson",
    permissionsTitle: "Yetkiler",
    perm_manage_tables: "Masa işlemleri (hesap aç/kapat)",
    perm_manage_quick_orders: "Sipariş işlemleri",
    perm_manage_customers: "Müşteri erişimi",
    perm_access_payments: "Kasa erişimi",
    perm_manage_payments: "Kasadan silme",
    perm_manage_tanimlar: "Tanımlar (depo, masa vb.)",
    perm_manage_restaurants: "Genel ayarlar",
    searchPlaceholder: "Ad, e-posta veya rol ara…",
    statTotal: "Toplam personel",
    permCount: "yetki",
    empty: "Henüz personel yok",
    deleteConfirm: "{name} silinsin mi?",
    added: "Personel eklendi",
    updated: "Personel güncellendi",
    deleted: "Personel silindi",
    loadError: "Personel yüklenemedi",
    saveError: "İşlem başarısız",
    errName: "Ad gerekli",
    errNameLong: "Ad çok uzun",
    errEmail: "E-posta gerekli",
    errEmailInvalid: "Geçersiz e-posta",
    errType: "Rol seçin",
    errPermissions: "En az bir yetki seçin",
    errPassword: "Şifre gerekli",
    errPasswordShort: "Şifre en az 6 rakam olmalıdır",
    errPasswordMatch: "Şifreler eşleşmiyor",
  },
  expenses: {
    title: "Kategoriler",
    newCategory: "Yeni kategori adı",
    total: "Toplam",
    amount: "Tutar",
    reason: "Sebep",
    addExpense: "Gider ekle",
    noCategory: "Kategori seçilmedi",
  },
  material: {
    addTitle: "Hammadde ekle",
    name: "Adı",
    namePlaceholder: "Hammadde adı…",
    unit: "Birim",
    selectUnit: "Birim seçin",
    unitPiece: "Adet",
    listTitle: "Mevcut hammaddeler",
    quantity: "Miktar",
    actions: "İşlemler",
    deleted: "Hammadde silindi",
    updated: "Hammadde güncellendi",
    noLogs: "Log bulunamadı",
  },
  account: {
    inactive: "Hesabınız aktif değil. Aktifleştirmek için {phone} ile iletişime geçin.",
  },
  accessDenied: "Bu işlem için yetkiniz yok",
  notFound: {
    title: "Sayfa bulunamadı.",
    desc: "Aradığınız sayfa mevcut değil.",
    home: "Ana sayfaya dön",
  },
};

const ru = {
  common: {
    loading: "Загрузка…",
    save: "Сохранить",
    delete: "Удалить",
    back: "Назад",
    all: "Все",
    detail: "Детали",
    update: "Обновить",
    add: "Добавить",
    filter: "Фильтр",
    clear: "Очистить",
    print: "Печать",
    empty: "Свободен",
    occupied: "Занят",
    yes: "Да",
    no: "Нет",
    close: "Закрыть",
    continue: "Продолжить",
    user: "Пользователь",
    logout: "Выход",
    menu: "Меню",
    order: "Заказ",
    posSystem: "POS система",
    definitions: "Справочники",
    unknownError: "Произошла неизвестная ошибка",
    listCount: "В списке всего {count} записей.",
  },
  lang: {
    settingsTitle: "Настройки языка",
    settingsDesc:
      "Язык интерфейса. Сохраняется для ресторана на всех устройствах.",
    current: "Текущий язык",
    save: "Сохранить язык",
    saved: "Язык обновлён",
    saveError: "Не удалось сохранить язык",
    loadError: "Не удалось загрузить язык",
  },
  nav: {
    dashboard: "Панель",
    tables: "Столы",
    orders: "Заказы",
    customers: "Клиенты",
    cash: "Касса",
    warehouseProducts: "Складские товары",
    rawMaterials: "Сырьё",
    sets: "Наборы",
    staffRegistration: "Регистрация персонала",
    courierRegistration: "Регистрация курьеров",
    tableSettings: "Настройки столов",
    generalSettings: "Общие настройки",
    telegramBot: "Telegram Bot",
    expenses: "Расходы",
    groupWarehouse: "Склад и товары",
    groupStaff: "Персонал и курьеры",
    groupSettings: "Настройки",
    groupFinance: "Финансы",
    backupReady: "Резервная копия готова! {count} записей. {errors} недоступно.",
    webOrders: "Web-заказы",
    webOrdersHint: "Заказы с онлайн-меню",
    webOrdersEmpty: "Нет web-заказов",
    webOrdersAll: "Все web-заказы →",
    newWebOrder: "Новый web-заказ!",
    webOrderDetail: "Детали заказа",
    webOrdersPending: "ожидающих заказов",
    webOrderAccept: "Принять",
    webOrderAcceptOpen: "Принять и открыть",
    webOrderReject: "Отменить",
    webOrderRejectConfirm: "Отменить этот web-заказ?",
    webOrderRejected: "Заказ отменён",
    webOrderAccepted: "Заказ принят",
    webOrderActionError: "Ошибка операции",
    webOrderDetailError: "Не удалось загрузить детали",
    webOrderCustomer: "Данные клиента",
    webOrderFullPage: "Открыть полностью",
  },
  login: {
    emailPasswordRequired: "Требуются email и пароль",
    invalidCredentials: "Неверный email или пароль",
    dbConnection: "Нет подключения к БД API. START_FULL_DEV.bat или use-local-sqlite.ps1.",
    apiUnavailable: "Вход не выполнен. API работает?",
    retry: "Вход не выполнен. Повторите попытку.",
    tagline: "Система управления рестораном",
    headline: "Управляйте рестораном умно",
    heroDesc: "Столы, заказы, склад и отчёты — всё в одном месте.",
    welcome: "Добро пожаловать",
    subtitle: "Войдите в аккаунт для продолжения",
    email: "Email",
    password: "Пароль",
    remember: "Запомнить меня",
    forgotPassword: "Забыли пароль?",
    submit: "Войти",
    submitting: "Вход…",
    showPassword: "Показать",
    hidePassword: "Скрыть",
    headlineLine1: "Управляйте",
    headlineHighlight: "рестораном",
    headlineLine2: "умно",
    featureMobileTitle: "Мобильная версия",
    featureMobileText: "Телефон, планшет и компьютер",
    featureReportsTitle: "Живые отчёты",
    featureReportsText: "Касса и продажи в реальном времени",
    featureSecureTitle: "Безопасность",
    featureSecureText: "Данные защищены шифрованием",
    copyright: "Все права защищены",
    noAccount: "Нет аккаунта? Свяжитесь для демо",
  },
  settings: {
    title: "Общие настройки",
    selectCategory: "Выберите категорию",
    tabGeneral: "Настройки",
    tabGeneralDesc: "Ресторан, логотип, принтеры, цвета",
    tabPassword: "Настройки паролей",
    tabPasswordDesc: "Пароли по разделам",
    tabLanguage: "Настройки языка",
    tabLanguageDesc: "Турецкий, русский, азербайджанский",
    tabWeb: "Web-настройки",
    tabWebDesc: "Онлайн-меню, ссылка, домен",
    tabAppearance: "Внешний вид",
    tabAppearanceDesc: "Скрыть / показать страницы меню и функции",
    tabTelegram: "Telegram Bot",
    tabTelegramDesc: "Уведомления о заказах и кассе",
    mainMenuSection: "Основное меню",
    tanimMenuSection: "Меню «Определения»",
    featuresSection: "Функции",
    featuresSectionDesc: "Кнопки на страницах и дополнительные функции",
    featureQuickSale: "Быстрая продажа",
    featureQuickSaleDesc: "Кнопка быстрой продажи на странице заказов",
    optionsSection: "Поведение",
    optionsSectionDesc: "Автооткрытие при входе на страницу и др.",
    optionQuickSaleAuto: "Авто быстрая продажа",
    optionQuickSaleAutoDesc: "При открытии заказов сразу быстрая продажа; после оплаты снова открывается",
    pagesVisible: "страниц видно",
    appearanceSaved: "Настройки внешнего вида сохранены",
    appearanceSaveError: "Не удалось сохранить настройки внешнего вида",
    generalIntro: "Профиль ресторана, принтеры, цвета столов и часы работы.",
    saved: "Параметры успешно обновлены",
    profileSection: "Профиль и логотип",
    profileLogo: "Логотип (.jpg, .png) — необязательно",
    restaurantName: "Название кафе / ресторана",
    receiptFooter: "Сообщение внизу чека",
    qrEnable: "Включить QR-меню",
    qrOrders: "Принимать заказы из QR-меню",
    printers: "Принтеры",
    mainPrinter: "Основной принтер",
    kitchenPrinter: "Кухонный принтер",
    barPrinter: "Барный принтер",
    tableColors: "Цвета столов и PS Club",
    emptyTable: "Свободный стол",
    bookedTable: "Занятый стол",
    psClub: "PS Club",
    psActive: "Активен",
    psOff: "Выключен",
    saveChanges: "Сохранить изменения",
  },
  webSettings: {
    title: "Web-настройки",
    intro: "Отдельно от QR столов — одна ссылка для доставки. Можно подключить свой домен.",
    loading: "Загрузка...",
    loadError: "Не удалось загрузить web-настройки",
    saved: "Web-настройки сохранены",
    saveError: "Ошибка сохранения",
    save: "Сохранить",
    publicLink: "Публичная ссылка меню",
    publicLinkHint: "Для Instagram bio и т.д. QR столов остаются отдельно.",
    slug: "Имя ссылки (slug)",
    slugHint: "Только строчные буквы, цифры и дефис",
    copy: "Копировать",
    linkCopied: "Ссылка скопирована",
    copyFailed: "Не удалось скопировать",
    preview: "Открыть меню",
    menuActive: "Web-меню активно",
    acceptOrders: "Принимать онлайн-заказы (в раздел Заказы)",
    customDomain: "Свой домен",
    customDomainIntro: "Следуйте шагам ниже или свяжитесь с поддержкой.",
    domainField: "Домен (напр. menu.restaurant.ru)",
    domainNone: "Домен не указан",
    domainPending: "Ожидает — поддержка активирует",
    domainActive: "Активен",
    dnsTitle: "Настройка DNS",
    dnsStep1: "CNAME: menu → login.smartcafe.az",
    dnsStep2: "Или A-запись на IP сервера (поможет поддержка)",
    dnsStep3: "После ввода домена напишите нам — активируем на сервере",
    dnsSupport: "Нужна помощь — обратитесь в поддержку SmartCafe.",
    domainNote: "Заметка о домене (для поддержки)",
    domainNotePlaceholder: "напр. menu.bistro.ru — прошу активировать",
    design: "Дизайн",
    templatePick: "Шаблон web-меню",
    templatePickHint: "Выберите дизайн для публичной ссылки.",
    template_classic: "Классика — светлый",
    template_flame: "Flame — тёмный, красный",
    template_modern: "Modern — градиент",
    webTitle: "Заголовок",
    webSubtitle: "Подзаголовок",
    themeColor: "Основной цвет",
    bgColor: "Фон",
    logoFromProfile: "Логотип из общих настроек",
    bannerImage: "Баннер (фон за логотипом)",
    bannerHint: "Загрузите широкий баннер — логотип будет поверх. Рекомендуется: 1200×400 px",
    bannerUpload: "Выбрать баннер",
    bannerRemove: "Удалить баннер",
    bannerRemoved: "Баннер удалён",
    bioLinks: "Соцсети",
    bioLinksHint: "Местоположение, TikTok и WhatsApp вместо сайта.",
    locationUrl: "Местоположение (Google Maps)",
    website: "Сайт",
    promoCode: "Промо-код",
    comingSoon: "Этот раздел скоро будет доступен.",
    layoutHint: "Выберите раздел в меню слева",
    promoSettings: "Настройки промо",
    promoSettingsHint: "Минимальная сумма заказа и промокоды.",
    minOrderAmount: "Минимальная сумма заказа (₼)",
    minOrderHint: "Если пусто — минимум не применяется.",
    promoLoadError: "Не удалось загрузить промокоды",
    promoSaved: "Промокод сохранён",
    promoSaveError: "Не удалось сохранить промокод",
    promoCodeRequired: "Введите промокод",
    promoDeleteConfirm: "Удалить промокод?",
    promoDeleted: "Промокод удалён",
    promoEdit: "Редактировать промокод",
    promoNew: "Новый промокод",
    promoCodeField: "Код",
    promoTitle: "Заголовок",
    promoDescription: "Описание",
    promoDiscountType: "Тип скидки",
    promoPercent: "Процент (%)",
    promoFixed: "Фиксированная сумма",
    promoValue: "Значение",
    promoMaxUses: "Макс. использований (пусто = без лимита)",
    promoValidFrom: "Начало",
    promoValidUntil: "Окончание",
    promoActive: "Активен",
    promoInactive: "Неактивен",
    promoAdd: "Добавить",
    promoUpdate: "Обновить",
    promoCancel: "Отмена",
    promoList: "Промокоды",
    promoEmpty: "Промокодов пока нет.",
    promoUses: "Использовано: {count} / {max}",
  },
  pwd: {
    title: "Настройки паролей",
    subtitle: "PIN-коды хранятся в MySQL как bcrypt hash.",
    custom: "Свой",
    default: "По умолчанию",
    disabled: "Отключено",
    setPassword: "Установить пароль",
    newPassword: "Новый пароль",
    hintEnter: "4-6 цифр",
    hintConfirm: "Повторите для подтверждения",
    keypadClear: "Очистить",
    keypadBack: "Назад",
    keypadSave: "Сохранить",
    keypadSaving: "Сохранение…",
    minDigits: "Пароль должен быть не менее 4 цифр",
    mismatch: "Пароли не совпадают",
    azaltmaLabel: "Уменьшение товара",
    azaltmaDesc: "Пароль для уменьшения количества на столе",
    silmeLabel: "Удаление",
    silmeDesc: "Пароль для удаления товара со стола",
    legvLabel: "Отмена стола",
    legvDesc: "Пароль для закрытия / отмены стола",
    anbarLabel: "Склад",
    anbarDesc: "Пароль для настроек склада и товаров",
    kassaLabel: "Касса",
    kassaDesc: "Пароль для кассы и финансовых отчётов",
    ekranLabel: "Блокировка экрана",
    ekranDesc: "PIN для блокировки экрана при простое POS",
    screenLockTitle: "Время блокировки экрана",
    screenLockDesc: "Если POS не используется, запрашивается PIN блокировки.",
    screenLockIdle: "Время простоя",
    screenLockHint: "Блокировка экрана должна быть включена, время > 0.",
    screenLockSaved: "Время блокировки сохранено",
    screenLockOff: "Выключено",
    screenLock30: "30 секунд",
    screenLock60: "1 минута",
    screenLock120: "2 минуты",
    screenLock180: "3 минуты",
    screenLock300: "5 минут",
    screenLock600: "10 минут",
  },
  masalar: {
    totalTables: "Всего столов",
    empty: "Свободен",
    occupied: "Занят",
    activeTurnover: "Активный оборот",
    search: "Поиск стола…",
    refresh: "Обновить",
    tableSettings: "Настройки столов",
    noTables: "Столы не найдены",
    tableOptions: "Опции стола",
  },
  masaSiparis: {
    productAdded: "Товар добавлен",
    orderName: "Название заказа",
    tables: "Столы",
    menu: "Меню",
    order: "Заказ",
    psTime: "PS время",
  },
  siparisler: {
    title: "Заказы",
    subtitle: "Управление доставкой и web-заказами",
    addNew: "Добавить заказ",
    fullName: "ФИО",
    time: "Время",
    total: "Итого",
    phone: "Телефон",
    address: "Адрес",
    courier: "Курьер",
    closeBill: "Закрыть счёт",
    saleComplete: "Продажа завершена",
    tabWeb: "Web-заказы",
    tabManual: "Телефон / вручную",
    searchPlaceholder: "Поиск по имени, телефону, адресу…",
    statAll: "Всего заказов",
    statWeb: "Web-заказы",
    statWebPending: "Ожидающие web",
    statTotal: "Общая сумма",
    empty: "Заказы не найдены",
    openMap: "Открыть карту",
    assignCourier: "Назначить курьера",
    actions: "Действия",
    loadError: "Не удалось загрузить заказы",
    deleteConfirm: "Удалить этот заказ?",
    deleted: "Заказ удалён",
    courierAssigned: "Курьер назначен",
    addModalSubtitle: "Введите данные клиента, затем выберите товары",
    namePlaceholder: "Напр.: Иван Иванов",
    phonePlaceholder: "+994 XX XXX XX XX",
    addressPlaceholder: "Улица, дом, квартира…",
    useLocation: "Отправить GPS",
    locationAdded: "Местоположение добавлено",
    locationError: "Не удалось получить местоположение",
    locationUnsupported: "Браузер не поддерживает геолокацию",
    fieldRequired: "Имя, телефон и адрес обязательны",
    continueToMenu: "Выбрать товары →",
    quickSale: "Быстрая продажа",
    quickSaleHint: "Нажмите на товар — заказ готов (данные клиента необязательны)",
    customerOptionalHint: "Данные клиента необязательны — можно продать без заполнения",
    anonymousCustomer: "Гость",
    fillCustomerFirst: "Сначала введите имя и адрес",
    searchProduct: "Поиск товара…",
  },
  musteriSiparis: {
    title: "Создать заказ",
    subtitle: "Добавьте товары, закройте счёт и доставьте",
    customerInfo: "Данные клиента",
    updateCustomer: "Сохранить данные",
    customerUpdated: "Данные клиента обновлены",
    currentCart: "Текущий заказ",
    menuProducts: "Меню товаров",
    noItems: "Товары ещё не добавлены",
    prepayment: "Предоплата",
    paid: "Оплачено",
    remaining: "Остаток",
    sendKitchen: "На кухню",
    sendToKitchen: "Отправить на кухню",
    colName: "Название",
    colQty: "Кол-во",
    colKitchen: "Кухня",
    selectVariant: "Выберите вариант",
    addToOrder: "Добавить в заказ",
    specialOrders: "Особые заказы",
    specialIngredient: "Особый ингредиент",
    ingredientPlaceholder: "Введите ингредиент",
  },
  musteriler: {
    title: "Клиенты",
    addNew: "Добавить клиента",
    filterName: "Фильтр по имени",
    filterPhone: "Фильтр по телефону",
    selectCustomer: "Выберите клиента",
  },
  gunlukKasa: {
    title: "Ежедневная касса",
    subtitle: "Платежи, наличные и банк",
    start: "Начало",
    end: "Конец",
    paymentType: "Способ оплаты",
    cash: "Наличные",
    card: "Банк / карта",
    tableOrName: "Стол / ФИО",
    opened: "Открытие",
    closed: "Закрытие",
    duration: "Длительность",
    amount: "Сумма",
    statTotal: "Всего в кассе",
    statCash: "Наличные",
    statBank: "Банк",
    statCount: "Операций",
    searchPlaceholder: "Поиск стола или имени…",
    employee: "Сотрудник",
    detail: "Подробнее",
    orders: "Заказы",
    itemName: "Товар",
    qty: "Кол-во",
    price: "Цена",
    printReceipt: "Печать чека",
    deleteConfirm: "Удалить этот платёж?",
    deleted: "Платёж удалён",
    empty: "Платежи не найдены",
    loadError: "Не удалось загрузить кассу",
    paymentSplit: "Частями",
    customerBalance: "Счёт клиента",
    exportExcel: "Excel",
    exportPdf: "PDF",
    reportPrint: "Печать отчёта",
    registerOpen: "Открыть кассу",
    registerClose: "Закрыть кассу",
    registerIsOpen: "Касса открыта",
    registerIsClosed: "Касса закрыта",
    registerOpened: "Касса открыта",
    registerClosed: "Касса закрыта",
    registerOpenedAt: "Открытие",
    registerSessionTotal: "Итого за смену",
    registerCloseConfirm: "Закрыть кассу?",
    registerToggleError: "Ошибка операции с кассой",
  },
  stok: {
    title: "Добавление товара на склад",
    addNew: "Добавить товар",
    addGroup: "Добавить группу",
    resetInventory: "Сбросить склад",
    resetConfirm: "Сбросить склад?",
    resetSuccess: "Склад успешно сброшен",
    name: "Название",
    stock: "Остаток",
    salePrice: "Цена продажи",
    qrMenu: "QR-меню",
    group: "Группа",
    woltImportTitle: "Импорт меню из Wolt",
    woltImportHint: "Вставьте ссылку на ресторан Wolt",
    woltUrlPlaceholder: "https://wolt.com/.../restaurant/...",
    woltUrlRequired: "Введите ссылку Wolt",
    woltFetch: "Загрузить меню",
    woltPreviewError: "Не удалось загрузить меню Wolt",
    woltCategories: "категорий",
    woltProducts: "товаров",
    woltShowOnQr: "Показывать в QR-меню",
    woltSkipExisting: "Пропускать существующие",
    woltDownloadImages: "Скачать изображения",
    woltDefaultStock: "Остаток по умолчанию",
    woltSearchItems: "Поиск товара…",
    woltSelectAll: "Выбрать все",
    woltClearAll: "Снять выбор",
    woltSelectItems: "Выберите хотя бы один товар",
    woltImportConfirm: "Добавить {count} товаров на склад?",
    woltImportBtn: "Импорт на склад",
    woltImportDone: "Импорт завершён",
    woltAdded: "добавлено",
    woltSkipped: "пропущено",
    woltImportError: "Ошибка импорта",
    woltImportWait: "Импорт может занять несколько минут…",
  },
  couriers: {
    title: "Курьеры",
    addNew: "+ Добавить курьера",
    fullName: "ФИО",
    phone: "Телефон",
    address: "Адрес",
  },
  masaTanimlari: {
    groupsTitle: "Группы столов",
    newGroup: "Новая группа",
    tablesTitle: "Столы",
    newTable: "+ Новый стол",
    tableName: "Название стола",
    group: "Группа",
    unspecified: "Не указано",
  },
  personel: {
    title: "Персонал",
    subtitle: "Регистрация, роли и права",
    addNew: "Новый сотрудник",
    addTitle: "Добавить сотрудника",
    editTitle: "Редактировать",
    fullName: "ФИО",
    email: "Email",
    type: "Роль",
    password: "Пароль",
    passwordHint: "Минимум 6 цифр (PIN)",
    passwordConfirm: "Подтверждение",
    newPassword: "Новый пароль",
    passwordOptional: "Оставьте пустым, чтобы не менять",
    selectRole: "Выберите роль",
    roleGeneral: "Менеджер",
    roleWaiter: "Официант",
    permissionsTitle: "Права доступа",
    perm_manage_tables: "Столы (открыть/закрыть счёт)",
    perm_manage_quick_orders: "Заказы",
    perm_manage_customers: "Клиенты",
    perm_access_payments: "Доступ к кассе",
    perm_manage_payments: "Удаление из кассы",
    perm_manage_tanimlar: "Справочники",
    perm_manage_restaurants: "Общие настройки",
    searchPlaceholder: "Поиск по имени, email, роли…",
    statTotal: "Всего",
    permCount: "прав",
    empty: "Сотрудников пока нет",
    deleteConfirm: "Удалить {name}?",
    added: "Сотрудник добавлен",
    updated: "Сотрудник обновлён",
    deleted: "Сотрудник удалён",
    loadError: "Не удалось загрузить",
    saveError: "Ошибка операции",
    errName: "Имя обязательно",
    errNameLong: "Имя слишком длинное",
    errEmail: "Email обязателен",
    errEmailInvalid: "Некорректный email",
    errType: "Выберите роль",
    errPermissions: "Выберите хотя бы одно право",
    errPassword: "Пароль обязателен",
    errPasswordShort: "Пароль — минимум 6 цифр",
    errPasswordMatch: "Пароли не совпадают",
  },
  expenses: {
    title: "Категории",
    newCategory: "Название категории",
    total: "Итого",
    amount: "Сумма",
    reason: "Причина",
    addExpense: "Добавить расход",
    noCategory: "Категория не выбрана",
  },
  material: {
    addTitle: "Добавить сырьё",
    name: "Название",
    namePlaceholder: "Название сырья…",
    unit: "Единица",
    selectUnit: "Выберите единицу",
    unitPiece: "Штука",
    listTitle: "Сырьё",
    quantity: "Количество",
    actions: "Действия",
    deleted: "Сырьё удалено",
    updated: "Сырьё обновлено",
    noLogs: "Логи не найдены",
  },
  account: {
    inactive: "Аккаунт неактивен. Свяжитесь с {phone} для активации.",
  },
  accessDenied: "У вас нет прав для этого действия",
  notFound: {
    title: "Страница не найдена.",
    desc: "Запрашиваемая страница не существует.",
    home: "На главную",
  },
};

const en = {
  common: {
    loading: "Loading…",
    save: "Save",
    delete: "Delete",
    back: "Back",
    all: "All",
    detail: "Details",
    update: "Update",
    add: "Add",
    filter: "Filter",
    clear: "Clear",
    print: "Print",
    empty: "Empty",
    occupied: "Occupied",
    yes: "Yes",
    no: "No",
    close: "Close",
    continue: "Continue",
    user: "User",
    logout: "Log out",
    menu: "Menu",
    order: "Order",
    posSystem: "POS System",
    definitions: "Definitions",
    unknownError: "An unknown error occurred",
    listCount: "{count} records in list.",
  },
  lang: {
    settingsTitle: "Language settings",
    settingsDesc:
      "Interface language. Saved for your restaurant on all devices.",
    current: "Current language",
    save: "Save language",
    saved: "Language updated",
    saveError: "Could not save language",
    loadError: "Could not load language",
  },
  nav: {
    dashboard: "Dashboard",
    tables: "Tables",
    orders: "Orders",
    customers: "Customers",
    cash: "Cash register",
    warehouseProducts: "Warehouse products",
    rawMaterials: "Raw materials",
    sets: "Sets",
    staffRegistration: "Staff registration",
    courierRegistration: "Courier registration",
    tableSettings: "Table settings",
    generalSettings: "General settings",
    telegramBot: "Telegram Bot",
    expenses: "Expenses",
    groupWarehouse: "Warehouse & products",
    groupStaff: "Staff & couriers",
    groupSettings: "Settings",
    groupFinance: "Finance",
    backupReady: "Backup ready! {count} records. {errors} endpoints unavailable.",
    webOrders: "Web orders",
    webOrdersHint: "Online menu orders",
    webOrdersEmpty: "No web orders",
    webOrdersAll: "All web orders →",
    newWebOrder: "New web order!",
    webOrderDetail: "Order details",
    webOrdersPending: "pending orders",
    webOrderAccept: "Accept",
    webOrderAcceptOpen: "Accept & open",
    webOrderReject: "Cancel",
    webOrderRejectConfirm: "Cancel this web order?",
    webOrderRejected: "Order cancelled",
    webOrderAccepted: "Order accepted",
    webOrderActionError: "Action failed",
    webOrderDetailError: "Could not load details",
    webOrderCustomer: "Customer info",
    webOrderFullPage: "Open full page",
  },
  login: {
    emailPasswordRequired: "Email and password are required",
    invalidCredentials: "Invalid email or password",
    dbConnection: "Cannot connect to API database. Use START_FULL_DEV.bat or use-local-sqlite.ps1.",
    apiUnavailable: "Login failed. Is the API running?",
    retry: "Login failed. Please try again.",
    tagline: "Restaurant management system",
    headline: "Manage your restaurant smartly",
    heroDesc: "Tables, orders, stock and reports — all in one place.",
    welcome: "Welcome",
    subtitle: "Sign in to your account to continue",
    email: "Email",
    password: "Password",
    remember: "Remember me",
    forgotPassword: "Forgot password?",
    submit: "Sign in",
    submitting: "Signing in…",
    showPassword: "Show",
    hidePassword: "Hide",
    headlineLine1: "Manage your restaurant",
    headlineHighlight: "smartly",
    headlineLine2: "",
    featureMobileTitle: "Mobile friendly",
    featureMobileText: "Phone, tablet and desktop",
    featureReportsTitle: "Live reports",
    featureReportsText: "Daily cash and sales analytics",
    featureSecureTitle: "Secure",
    featureSecureText: "Your data is protected with encryption",
    copyright: "All rights reserved",
    noAccount: "No account? Contact us for a demo",
  },
  settings: {
    title: "General settings",
    selectCategory: "Select category",
    tabGeneral: "Settings",
    tabGeneralDesc: "Restaurant, logo, printers, colors",
    tabPassword: "Password settings",
    tabPasswordDesc: "Section-based passwords",
    tabLanguage: "Language settings",
    tabLanguageDesc: "Turkish, Russian, English, Azerbaijani",
    tabWeb: "Web settings",
    tabWebDesc: "Online menu, link, domain",
    tabAppearance: "Appearance",
    tabAppearanceDesc: "Hide / show menu pages and features",
    tabTelegram: "Telegram Bot",
    tabTelegramDesc: "Order and cash notifications",
    mainMenuSection: "Main menu",
    tanimMenuSection: "Definitions menu",
    featuresSection: "Features",
    featuresSectionDesc: "In-page buttons and extra features",
    featureQuickSale: "Quick sale",
    featureQuickSaleDesc: "Quick sale button on the orders page",
    optionsSection: "Behavior options",
    optionsSectionDesc: "Auto-open on page enter and similar features",
    optionQuickSaleAuto: "Auto quick sale",
    optionQuickSaleAutoDesc: "Opens quick sale when entering orders; reopens after each sale",
    pagesVisible: "pages visible",
    appearanceSaved: "Appearance settings saved",
    appearanceSaveError: "Could not save appearance settings",
    generalIntro: "Restaurant profile, printers, table colors and hours.",
    saved: "Settings saved successfully",
    profileSection: "Profile and logo",
    profileLogo: "Logo (.jpg, .png) — optional",
    restaurantName: "Cafe / restaurant name",
    receiptFooter: "Receipt footer message",
    qrEnable: "Enable QR menu",
    qrOrders: "Accept orders from QR menu",
    printers: "Printers",
    mainPrinter: "Main printer",
    kitchenPrinter: "Kitchen printer",
    barPrinter: "Bar printer",
    tableColors: "Table colors & PS Club",
    emptyTable: "Empty table",
    bookedTable: "Occupied table",
    psClub: "PS Club",
    psActive: "Active",
    psOff: "Off",
    saveChanges: "Save changes",
  },
  webSettings: {
    title: "Web settings",
    intro: "Separate from table QR — one link for delivery orders. You can point your own domain.",
    loading: "Loading...",
    loadError: "Could not load web settings",
    saved: "Web settings saved",
    saveError: "Save failed",
    save: "Save",
    publicLink: "Public menu link",
    publicLinkHint: "Share for Instagram bio etc. Table QR codes stay separate.",
    slug: "Link name (slug)",
    slugHint: "Lowercase letters, numbers and hyphens only",
    copy: "Copy",
    linkCopied: "Link copied",
    copyFailed: "Copy failed",
    preview: "Preview menu",
    menuActive: "Web menu active",
    acceptOrders: "Accept online orders (appears in Orders)",
    customDomain: "Custom domain",
    customDomainIntro: "Follow the steps below or contact support to connect your domain.",
    domainField: "Domain (e.g. menu.yourrestaurant.com)",
    domainNone: "No domain",
    domainPending: "Pending — support will activate",
    domainActive: "Active",
    dnsTitle: "DNS setup",
    dnsStep1: "Add CNAME: menu → login.smartcafe.az",
    dnsStep2: "Or A record to server IP (support will help)",
    dnsStep3: "After entering domain, contact us — we activate on server",
    dnsSupport: "Contact SmartCafe support if you need help.",
    domainNote: "Domain note (for support)",
    domainNotePlaceholder: "e.g. menu.bistro.com — please activate",
    design: "Design",
    templatePick: "Web design template",
    templatePickHint: "Choose the layout for your public menu link.",
    template_classic: "Classic — light & clean",
    template_flame: "Flame — dark, red accent",
    template_modern: "Modern — gradient glass",
    webTitle: "Title",
    webSubtitle: "Subtitle",
    themeColor: "Primary color",
    bgColor: "Background",
    logoFromProfile: "Logo from general settings",
    bannerImage: "Banner image (logo background)",
    bannerHint: "Upload a wide banner — the logo appears on top. Recommended: 1200×400 px",
    bannerUpload: "Choose banner",
    bannerRemove: "Remove banner",
    bannerRemoved: "Banner removed",
    bioLinks: "Social links",
    bioLinksHint: "Restaurant location, TikTok and WhatsApp instead of website.",
    locationUrl: "Restaurant location (Google Maps)",
    website: "Website",
    promoCode: "Promo code",
    comingSoon: "This section will be available soon.",
    layoutHint: "Select a section from the left menu",
    promoSettings: "Promo settings",
    promoSettingsHint: "Manage minimum order amount and discount codes.",
    minOrderAmount: "Minimum order amount (₼)",
    minOrderHint: "Leave empty for no minimum limit.",
    promoLoadError: "Could not load promo codes",
    promoSaved: "Promo code saved",
    promoSaveError: "Could not save promo code",
    promoCodeRequired: "Enter a promo code",
    promoDeleteConfirm: "Delete this promo code?",
    promoDeleted: "Promo code deleted",
    promoEdit: "Edit promo",
    promoNew: "New promo code",
    promoCodeField: "Code",
    promoTitle: "Title",
    promoDescription: "Description",
    promoDiscountType: "Discount type",
    promoPercent: "Percent (%)",
    promoFixed: "Fixed amount",
    promoValue: "Value",
    promoMaxUses: "Max uses (empty = unlimited)",
    promoValidFrom: "Valid from",
    promoValidUntil: "Valid until",
    promoActive: "Active",
    promoInactive: "Inactive",
    promoAdd: "Add",
    promoUpdate: "Update",
    promoCancel: "Cancel",
    promoList: "Promo codes",
    promoEmpty: "No promo codes yet.",
    promoUses: "Uses: {count} / {max}",
  },
  pwd: {
    title: "Password settings",
    subtitle: "PIN codes are stored in MySQL as bcrypt hashes.",
    custom: "Custom",
    default: "Default",
    disabled: "Disabled",
    setPassword: "Set password",
    newPassword: "New password",
    hintEnter: "4-6 digits",
    hintConfirm: "Enter again to confirm",
    keypadClear: "Clear",
    keypadBack: "Back",
    keypadSave: "Save",
    keypadSaving: "Saving…",
    minDigits: "Password must be at least 4 digits",
    mismatch: "Passwords do not match",
    azaltmaLabel: "Reduce product",
    azaltmaDesc: "Password to reduce quantity on table",
    silmeLabel: "Delete",
    silmeDesc: "Password to remove product from table",
    legvLabel: "Cancel table",
    legvDesc: "Password to close / cancel table",
    anbarLabel: "Warehouse",
    anbarDesc: "Password for warehouse and product settings",
    kassaLabel: "Cash register",
    kassaDesc: "Password for daily cash and finance reports",
    ekranLabel: "Screen lock",
    ekranDesc: "PIN to lock the screen when POS is idle",
    screenLockTitle: "Screen lock timeout",
    screenLockDesc: "When POS is idle, the screen lock PIN is required.",
    screenLockIdle: "Idle timeout",
    screenLockHint: "Screen lock must be enabled and timeout must be greater than 0.",
    screenLockSaved: "Screen lock timeout saved",
    screenLockOff: "Off",
    screenLock30: "30 seconds",
    screenLock60: "1 minute",
    screenLock120: "2 minutes",
    screenLock180: "3 minutes",
    screenLock300: "5 minutes",
    screenLock600: "10 minutes",
  },
  masalar: {
    totalTables: "Total tables",
    empty: "Empty",
    occupied: "Occupied",
    activeTurnover: "Active turnover",
    search: "Search table…",
    refresh: "Refresh",
    tableSettings: "Table settings",
    noTables: "No tables found",
    tableOptions: "Table options",
  },
  masaSiparis: {
    productAdded: "Product added",
    orderName: "Order name",
    tables: "Tables",
    menu: "Menu",
    order: "Order",
    psTime: "PS time",
  },
  siparisler: {
    title: "Orders",
    subtitle: "Manage delivery and web orders",
    addNew: "Add new order",
    fullName: "Full name",
    time: "Time",
    total: "Total",
    phone: "Phone",
    address: "Address",
    courier: "Courier",
    closeBill: "Close bill",
    saleComplete: "Sale completed",
    tabWeb: "Web orders",
    tabManual: "Phone / manual",
    searchPlaceholder: "Search name, phone or address…",
    statAll: "Total orders",
    statWeb: "Web orders",
    statWebPending: "Pending web",
    statTotal: "Total amount",
    empty: "No orders found",
    openMap: "Open map",
    assignCourier: "Assign courier",
    actions: "Actions",
    loadError: "Could not load orders",
    deleteConfirm: "Delete this order?",
    deleted: "Order deleted",
    courierAssigned: "Courier assigned",
    addModalSubtitle: "Enter customer details, then pick products",
    namePlaceholder: "e.g. John Smith",
    phonePlaceholder: "+994 XX XXX XX XX",
    addressPlaceholder: "Street, building, apartment…",
    useLocation: "Send GPS location",
    locationAdded: "Location added",
    locationError: "Could not get location",
    locationUnsupported: "Browser does not support geolocation",
    fieldRequired: "Name, phone and address are required",
    continueToMenu: "Pick products →",
    quickSale: "Quick sale",
    quickSaleHint: "Click a product — order is ready (customer info optional)",
    customerOptionalHint: "Customer info is optional — you can sell without filling it in",
    anonymousCustomer: "Guest",
    fillCustomerFirst: "Enter name and address first",
    searchProduct: "Search product…",
  },
  musteriSiparis: {
    title: "Create order",
    subtitle: "Add products, close bill and deliver",
    customerInfo: "Customer details",
    updateCustomer: "Save details",
    customerUpdated: "Customer details updated",
    currentCart: "Current order",
    menuProducts: "Product menu",
    noItems: "No products added yet",
    prepayment: "Prepayment",
    paid: "Paid",
    remaining: "Remaining",
    sendKitchen: "Print to kitchen",
    sendToKitchen: "Send to kitchen",
    colName: "Name",
    colQty: "Qty",
    colKitchen: "Kitchen",
    selectVariant: "Select variant",
    addToOrder: "Add to order",
    specialOrders: "Special orders",
    specialIngredient: "Special ingredient",
    ingredientPlaceholder: "Enter ingredient",
  },
  musteriler: {
    title: "Customers",
    addNew: "Add new customer",
    filterName: "Name filter",
    filterPhone: "Phone filter",
    selectCustomer: "Please select a customer",
  },
  gunlukKasa: {
    title: "Daily cash",
    subtitle: "Payments, cash and bank report",
    start: "Start",
    end: "End date",
    paymentType: "Payment type",
    cash: "Cash",
    card: "Bank / card",
    tableOrName: "Table / Name",
    opened: "Opened",
    closed: "Closed",
    duration: "Duration",
    amount: "Total",
    statTotal: "Total cash",
    statCash: "Cash",
    statBank: "Bank",
    statCount: "Transactions",
    searchPlaceholder: "Search table or name…",
    employee: "Staff",
    detail: "Details",
    orders: "Orders",
    itemName: "Item",
    qty: "Qty",
    price: "Price",
    printReceipt: "Print receipt",
    deleteConfirm: "Delete this payment?",
    deleted: "Payment deleted",
    empty: "No payments found",
    loadError: "Could not load cash data",
    paymentSplit: "Split payment",
    customerBalance: "Customer account",
    exportExcel: "Excel",
    exportPdf: "PDF",
    reportPrint: "Print report",
    registerOpen: "Open register",
    registerClose: "Close register",
    registerIsOpen: "Register is open",
    registerIsClosed: "Register is closed",
    registerOpened: "Register opened",
    registerClosed: "Register closed",
    registerOpenedAt: "Opened at",
    registerSessionTotal: "Session total",
    registerCloseConfirm: "Close the cash register?",
    registerToggleError: "Register operation failed",
  },
  stok: {
    title: "Add warehouse product",
    addNew: "Add new stock",
    addGroup: "Add group / category",
    resetInventory: "Reset inventory",
    resetConfirm: "Reset inventory?",
    resetSuccess: "Inventory reset successfully",
    name: "Name",
    stock: "Stock",
    salePrice: "Sale price",
    qrMenu: "QR menu",
    group: "Group",
    woltImportTitle: "Import menu from Wolt",
    woltImportHint: "Paste a Wolt restaurant link",
    woltUrlPlaceholder: "https://wolt.com/.../restaurant/...",
    woltUrlRequired: "Enter Wolt link",
    woltFetch: "Fetch menu",
    woltPreviewError: "Could not load Wolt menu",
    woltCategories: "categories",
    woltProducts: "products",
    woltShowOnQr: "Show on QR menu",
    woltSkipExisting: "Skip existing names",
    woltDownloadImages: "Download images",
    woltDefaultStock: "Default stock qty",
    woltSearchItems: "Search items…",
    woltSelectAll: "Select all",
    woltClearAll: "Clear selection",
    woltSelectItems: "Select at least one item",
    woltImportConfirm: "Import {count} items to inventory?",
    woltImportBtn: "Import to inventory",
    woltImportDone: "Import complete",
    woltAdded: "added",
    woltSkipped: "skipped",
    woltImportError: "Import failed",
    woltImportWait: "Import may take a few minutes — please wait…",
  },
  couriers: {
    title: "Couriers",
    addNew: "+ Add courier",
    fullName: "Full name",
    phone: "Phone",
    address: "Address",
  },
  masaTanimlari: {
    groupsTitle: "Table groups",
    newGroup: "New table group",
    tablesTitle: "Tables",
    newTable: "+ New table",
    tableName: "Table name",
    group: "Group",
    unspecified: "Unspecified",
  },
  personel: {
    title: "Staff",
    subtitle: "Staff registration, roles and permissions",
    addNew: "New staff",
    addTitle: "Add staff member",
    editTitle: "Edit staff",
    fullName: "Full name",
    email: "Email",
    type: "Role",
    password: "Password",
    passwordHint: "At least 6 digits (PIN)",
    passwordConfirm: "Confirm password",
    newPassword: "New password",
    passwordOptional: "Leave blank to keep current",
    selectRole: "Select role",
    roleGeneral: "Manager",
    roleWaiter: "Waiter",
    permissionsTitle: "Permissions",
    perm_manage_tables: "Table operations",
    perm_manage_quick_orders: "Order operations",
    perm_manage_customers: "Customer access",
    perm_access_payments: "Cash register access",
    perm_manage_payments: "Delete payments",
    perm_manage_tanimlar: "Definitions (stock, tables)",
    perm_manage_restaurants: "General settings",
    searchPlaceholder: "Search name, email, role…",
    statTotal: "Total staff",
    permCount: "perms",
    empty: "No staff yet",
    deleteConfirm: "Delete {name}?",
    added: "Staff added",
    updated: "Staff updated",
    deleted: "Staff deleted",
    loadError: "Could not load staff",
    saveError: "Operation failed",
    errName: "Name is required",
    errNameLong: "Name is too long",
    errEmail: "Email is required",
    errEmailInvalid: "Invalid email",
    errType: "Select a role",
    errPermissions: "Select at least one permission",
    errPassword: "Password is required",
    errPasswordShort: "Password must be at least 6 digits",
    errPasswordMatch: "Passwords do not match",
  },
  expenses: {
    title: "Categories",
    newCategory: "New category name",
    total: "Total",
    amount: "Amount",
    reason: "Reason",
    addExpense: "Add expense",
    noCategory: "No category selected",
  },
  material: {
    addTitle: "Add raw material",
    name: "Name",
    namePlaceholder: "Material name…",
    unit: "Unit",
    selectUnit: "Select unit",
    unitPiece: "Piece",
    listTitle: "Raw materials",
    quantity: "Quantity",
    actions: "Actions",
    deleted: "Material deleted",
    updated: "Material updated",
    noLogs: "No logs found",
  },
  account: {
    inactive: "Your account is inactive. Contact {phone} to activate.",
  },
  accessDenied: "You do not have permission for this action",
  notFound: {
    title: "Page not found.",
    desc: "The page you are looking for does not exist.",
    home: "Back to home",
  },
};

function flatten(obj, prefix = "") {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (v && typeof v === "object" && !Array.isArray(v)) {
      Object.assign(out, flatten(v, key));
    } else {
      out[key] = v;
    }
  }
  return out;
}

export const messages = {
  az: flatten(az),
  tr: flatten(tr),
  ru: flatten(ru),
  en: flatten(en),
};

export { SUPPORTED_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./localesMeta";
